import * as actionTypes from './actionTypes';
export const patientSetup = (createPatientProfile, updateInformations, updateAccountSettings)=>({
        type: actionTypes.PATIENT_SETUP,
        payload: {
            createPatientProfile,
            updateInformations,
            updateAccountSettings
        }
    });
export const patientSetupSuccess = ()=>({
        type: actionTypes.PATIENT_SETUP_SUCCESS,
        payload: {}
    });
export const patientSetupError = (error)=>({
        type: actionTypes.PATIENT_SETUP_ERROR,
        error
    });
